module.exports = __webpack_public_path__ + "img/2014-hunara.7ffa8126.jpg";